import React from 'react';
import { Code2, GraduationCap, Rocket } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-24 bg-gradient-to-b from-transparent to-black/30">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">About Me</h2>
          <div className="w-20 h-1 bg-cyan-500 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-lg text-white/80 leading-relaxed">
              I'm a recent Computer Science graduate from <span className="text-cyan-400 font-semibold">BITS Pilani</span>, 
              currently working as an AI/ML Software Engineer with a passion for building intelligent systems.
            </p>
            <p className="text-lg text-white/80 leading-relaxed">
              My expertise lies in <span className="text-cyan-400 font-semibold">agentic AI frameworks</span> including 
              LangChain, LangGraph, and LlamaIndex, combined with strong programming skills in Python and Rust.
            </p>
            <p className="text-lg text-white/80 leading-relaxed">
              I'm enthusiastic about exploring the frontiers of AI, from RAG systems to multi-agent workflows, 
              and building production-ready solutions that make a real impact.
            </p>
          </div>

          <div className="space-y-6">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-all duration-300 hover:border-cyan-500/50">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-cyan-500/20 border border-cyan-500/30">
                  <GraduationCap size={24} className="text-cyan-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Education</h3>
                  <p className="text-white/70">Computer Science Graduate</p>
                  <p className="text-cyan-400 text-sm">BITS Pilani</p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-all duration-300 hover:border-cyan-500/50">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-cyan-500/20 border border-cyan-500/30">
                  <Code2 size={24} className="text-cyan-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Experience</h3>
                  <p className="text-white/70">AI/ML Software Engineer</p>
                  <p className="text-cyan-400 text-sm">1 Year of Experience</p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-all duration-300 hover:border-cyan-500/50">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-cyan-500/20 border border-cyan-500/30">
                  <Rocket size={24} className="text-cyan-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Passion</h3>
                  <p className="text-white/70">AI/ML Enthusiast</p>
                  <p className="text-cyan-400 text-sm">Building Intelligent Systems</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;